module.exports = __webpack_public_path__ + "static/media/image4.23335762.png";